import { type UseMutationResult, useMutation } from "@tanstack/react-query";
import { useRouteContext } from "@tanstack/react-router";

import { getAuthorizationHeaders } from "@/lib/authentication-headers";
import { env } from "@/lib/utils/env";

export function useLivanceAPIMutation<TData>(
  path: string,
  init: RequestInit,
  ignoreResponseData = false,
): UseMutationResult<TData> {
  const routeContext = useRouteContext({ from: "__root__" });
  const { authClient } = routeContext;

  return useMutation({
    mutationFn: async (variables): Promise<TData> => {
      const response = await fetch(`${env.VITE_LIVANCE_API_URL}/${path}`, {
        ...init,
        headers: {
          ...init.headers,
          ...(await getAuthorizationHeaders(authClient)),
        },
        body: JSON.stringify(variables),
      });

      if (response.ok) {
        return ignoreResponseData ? (null as TData) : ((await response.json()) as TData);
      }

      throw new Error("Erro ao fazer a requisição");
    },
  });
}
